import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
} from '@mui/material';

function ActiveStatusCard(props) {
  const {
    isActive, isAdAiMem, pauseData,
  } = props;

  return (
    <Card className="data-recency-card" variant="outlined" sx={{ p: 3 }}>
      <p className="is-active">
        <strong>Is Active:&nbsp;</strong>
        {isActive}
      </p>
      <p className="is-ad-ai">
        <strong>Is Advantage Member:&nbsp;</strong>
        {isAdAiMem}
      </p>
      <p className="pause-data">
        <strong>Pause Data:&nbsp;</strong>
        {pauseData}
      </p>
    </Card>
  );
}

export default ActiveStatusCard;

ActiveStatusCard.propTypes = {
  isActive: PropTypes.string,
  isAdAiMem: PropTypes.string,
  pauseData: PropTypes.string,
};
